import { render, staticRenderFns } from "./ModalTabsNew.vue?vue&type=template&id=4e9b94a7"
import script from "./ModalTabsNew.vue?vue&type=script&lang=ts"
export * from "./ModalTabsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9b94a7')) {
      api.createRecord('4e9b94a7', component.options)
    } else {
      api.reload('4e9b94a7', component.options)
    }
    module.hot.accept("./ModalTabsNew.vue?vue&type=template&id=4e9b94a7", function () {
      api.rerender('4e9b94a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalTabsNew.vue"
export default component.exports